import { call, put, takeLatest, select } from "@redux-saga/core/effects";
import { sentimentTrackerOnboardingApis } from "./sentimentTrackerOnboardingApis";
import { sentimentTrackerOnboardingParser } from "./sentimentTrackerOnboardingParser";
import { sentimentTrackerOnboardingConstants } from "./sentimentTrackerOnboardingConstants";
import { sentimentTrackerOnboardingActions } from "./sentimentTrackerOnboardingAction";
import { mergeKycWithLoginProfile } from "helper/ckycPrefill";

function* getOnboardingDataSaga() {
    try {
        yield put({
            type: sentimentTrackerOnboardingConstants.SENTIMENT_ONBOARDING_DATA_REQUEST,
        });

        const res = yield call(sentimentTrackerOnboardingApis.getOnboardingData);
        const payload = sentimentTrackerOnboardingParser.onboardingData(res);
        const loginProfile = yield select((state) => state.customer.loginProfile);

        yield put({
            type: sentimentTrackerOnboardingConstants.SENTIMENT_ONBOARDING_DATA_RESPONSE,
            payload,
        });

        const kyc = mergeKycWithLoginProfile(payload, loginProfile);

        yield put(
            sentimentTrackerOnboardingActions.updateSentimentTrackerOnboardingData({
                panNumber: kyc.panNumber,
                dateOfBirth: kyc.dateOfBirth,
                aadharNumber: kyc.aadharNumber,
            }),
        );
    } catch (e) {
        yield put({
            type: sentimentTrackerOnboardingConstants.SENTIMENT_ONBOARDING_DATA_RESPONSE,
            payload: {},
        });
    }
}

export function* registerSentimentTrackerOnboardingSagas() {

    yield takeLatest(
        sentimentTrackerOnboardingConstants.SENTIMENT_ONBOARDING_DATA_SAGA,
        getOnboardingDataSaga
    );

}
